// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.item_title__bt\\+VL {
  color: var(--mui-palette-primary-800);
  font-weight: 600;
}

.item_date__JJNpm {
  font-weight: 600;
  font-size: 10px;
  color: var(--mui-palette-grey-900);
}

.item_alertsTitle__7n4N6 {
  font-weight: 600;
  font-size: 10px;
  color: var(--mui-palette-error-dark);
  text-transform: uppercase;
  display: flex;
  align-items: center;
}

.item_resultDataTitle__osA4o {
  font-weight: 600;
  font-size: 10px;
  color: var(--mui-palette-primary-800);
  text-transform: uppercase;
  display: flex;
  align-items: center;
}

.item_resultDataTitle__osA4o svg path {
  fill: var(--mui-palette-primary-800);
}`, "",{"version":3,"sources":["webpack://./src/components/most/list/history/item/index.module.css"],"names":[],"mappings":"AAAA;EACE,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,oCAAoC;EACpC,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,qCAAqC;EACrC,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC","sourcesContent":[".title {\n  color: var(--mui-palette-primary-800);\n  font-weight: 600;\n}\n\n.date {\n  font-weight: 600;\n  font-size: 10px;\n  color: var(--mui-palette-grey-900);\n}\n\n.alertsTitle {\n  font-weight: 600;\n  font-size: 10px;\n  color: var(--mui-palette-error-dark);\n  text-transform: uppercase;\n  display: flex;\n  align-items: center;\n}\n\n.resultDataTitle {\n  font-weight: 600;\n  font-size: 10px;\n  color: var(--mui-palette-primary-800);\n  text-transform: uppercase;\n  display: flex;\n  align-items: center;\n}\n\n.resultDataTitle svg path {\n  fill: var(--mui-palette-primary-800);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `item_title__bt+VL`,
	"date": `item_date__JJNpm`,
	"alertsTitle": `item_alertsTitle__7n4N6`,
	"resultDataTitle": `item_resultDataTitle__osA4o`
};
export default ___CSS_LOADER_EXPORT___;
